import AffectNegative from './affect_negative.svg';
import AffectPositive from './affect_positive.svg';
import Anger from './anger.svg';
import DecreasePublication from './decrease_publication.svg';
import Disgust from './disgust.svg';
import Fear from './fear.svg';
import Hashtags from './hashtags.svg';
import ImageclusterDefault from './imagecluster_default.svg';
import IncreasePublication from './increase_publication.svg';
import Joy from './joy.svg';
import Love from './love.svg';
import Media from './media.svg';
import MentionKeyphrases from './mention_keyphrases.svg';
import MentionsAt from './mentions_at.svg';
import NegativePosts from './negative_posts.svg';
import PositivePosts from './positive_posts.svg';
import Review from './review.svg';
import Sadness from './sadness.svg';
import Surprise from './surprise.svg';
import Viral from './viral.svg';

export default {
  AffectNegative,  AffectPositive,  Anger,  DecreasePublication,  Disgust,  Fear,  Hashtags, IncreasePublication,
  ImageclusterDefault,  Joy,  Love,  Media,  MentionKeyphrases,  MentionsAt,  NegativePosts,  PositivePosts,  Review,
  Sadness,  Surprise,  Viral
}